import { useState, useCallback } from 'react';

import { api } from '@/services/api-class';

// ── Component ────────────────────────────────────────────────────────

/**
 * Public page reached from the unsubscribe link in client report emails:
 * /unsubscribe?unsubscribeId=...&clientId=... (the legacy
 * /unsubscribe-emails.html link redirects here with the same query string).
 */
export function UnsubscribeScreen() {
  const [params] = useState(() => {
    const urlParams = new URLSearchParams(window.location.search);
    return {
      unsubscribeId: urlParams.get('unsubscribeId'),
      clientId: urlParams.get('clientId'),
    };
  });
  const linkComplete = !!params.unsubscribeId && !!params.clientId;

  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState(
    linkComplete ? '' : 'This unsubscribe link is incomplete. Please use the link from your email.'
  );

  const handleSubmit = useCallback(
    (e?: React.FormEvent) => {
      if (e) e.preventDefault();
      if (!linkComplete) return;

      setSubmitting(true);
      setError('');

      const data = {
        unsubscribeId: params.unsubscribeId,
        clientId: params.clientId,
        unsubscribeFromAllClients: true,
      };

      api.unsubscribeEmails(
        data,
        () => {
          setSubmitting(false);
          setDone(true);
        },
        () => {
          setSubmitting(false);
          setError('Your request could not be processed. Please try again.');
        }
      );
    },
    [linkComplete, params]
  );

  return (
    <div className="kst-registration-page">
      {/* Background Panel */}
      <div
        className="kst-registration-bg"
        style={{ backgroundImage: "url('images/bg-01.jpg')" }}
      />

      {/* Form Panel */}
      <div className="kst-registration-form-panel">
        <form className="kst-registration-form" onSubmit={handleSubmit}>
          <h1 className="kst-registration-title">Unsubscribe Emails</h1>

          {error && (
            <div className="kst-reg-error kst-reg-error--general">{error}</div>
          )}

          {done ? (
            <div>
              <p>You have been unsubscribed from all client report emails.</p>
              <p>
                Marketing emails from Kerkton Security Technologies are managed separately.
                To stop those, use the unsubscribe link in a marketing email.
              </p>
            </div>
          ) : (
            <>
            <p>
              This stops all client report emails sent to this address (activity reports,
              call notifications and report approvals) for every client it is listed on.
              To receive them again, ask the security company that sends them to add you back.
            </p>
            <div className="kst-reg-submit-container">
              <button
                type="submit"
                className="kst-reg-submit-btn"
                disabled={submitting || !linkComplete}
              >
                {submitting ? 'Unsubscribing...' : 'Unsubscribe from Client Reports'}
              </button>
            </div>
            </>
          )}
        </form>
      </div>
    </div>
  );
}

export default UnsubscribeScreen;
